import React from "react";
import styles from "@aspen/widgets/login/Login.module.less";
import { LoginLayoutPortal, ResetPasswordAll } from "@aspen/widgets";
import type { ILoading } from "@aspen/model";

interface IProps {
  updateStatus: (status: ILoading) => void;
}

interface IState {
  userName: string;
  resetToken: string;
  showStep2: boolean;
}

class ResetPassword extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      userName: "",
      resetToken: "",
      showStep2: false
    };

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(userName: string, resetToken: string): void {
    this.setState({
      userName,
      resetToken,
      showStep2: true
    });
  }

  componentDidMount(): void {
    // this.props.updateStatus("success");
  }

  render(): React.ReactNode {
    return (
      <>
        <div className={styles.form}>
          <ResetPasswordAll />
        </div>
      </>
    );
  }
}

export default LoginLayoutPortal(ResetPassword);
